import React from "react";
import { observer } from "mobx-react";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import WorkoutDetailsStore from "stores/WorkoutDetailsStore";

import { Page } from "components/Layout";
import Movement from "components/Workout/WorkoutMovement";

import WorkoutNavList from "pages/WorkoutMain/NavList";
import SearchNavList from "pages/Search/NavList";
import CalendarNavList from "pages/Calendar/NavList";

import ROUTES from "navigation/routes";

type Params = {
  workoutId: string;
  movementId: string;
  categoryId?: string;
  workoutGroup?: string;
  workoutInWorkoutCategoryId?: string;
  scheduleDate?: string;
};

const WorkoutMovement: React.FC = observer(() => {
  const params = useParams<Params>();
  const location = useLocation();
  const navigate = useNavigate();

  const categoryId = params.categoryId
    ? Number.parseInt(params.categoryId)
    : undefined;
  const workoutId = params.workoutId
    ? Number.parseInt(params.workoutId)
    : undefined;
  const movementId = params.movementId
    ? Number.parseInt(params.movementId)
    : undefined;
  const workoutInWorkoutCategoryId = params.workoutInWorkoutCategoryId
    ? Number.parseInt(params.workoutInWorkoutCategoryId)
    : undefined;
  const workoutGroup = params.workoutGroup;
  const url = location.pathname;

  const isWorkout = url.includes(ROUTES.WORKOUT);
  const isSearch = url.includes(ROUTES.SEARCH);
  const isCalendar = url.includes(ROUTES.CALENDAR);
  const isToday = url.includes(ROUTES.TODAY);

  const navList = isSearch ? (
    <SearchNavList />
  ) : isWorkout || isToday ? (
    <WorkoutNavList />
  ) : isCalendar ? (
    <CalendarNavList />
  ) : undefined;

  const details = movementId
    ? WorkoutDetailsStore.getMovementDetails(movementId)
    : undefined;

  return (
    <Page title={details?.title} topNavigation={navList}>
      <Movement
        workoutId={workoutId ?? null}
        movementId={movementId ?? null}
        categoryId={categoryId ?? null}
        workoutGroup={workoutGroup}
        workoutInWorkoutCategoryId={workoutInWorkoutCategoryId}
        url={url}
        history={navigate}
      ></Movement>
    </Page>
  );
});

export default WorkoutMovement;
